// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__z191H","selected":"Chip_selected__1nzOK"};